import { stimulusApplication } from "./application"
import HomeSalesCounterController from "./home_sales_counter_controller"

const application = stimulusApplication()
application.register("home-sales-counter", HomeSalesCounterController)
